import React from 'react';
import { Helmet } from 'react-helmet';

function Livenesscheck_Seo() {
    return (
        <div>
            <Helmet>
                <title>Liveness check to capture selfie image | Ifepay</title>
                <meta name="description" content="Complete the KYC process by following simple steps like, Look straight, Smile, Frown, turn right. It take maximum of 30 seconds to complete Liveness check." />
                <meta property="og:title" content="Liveness check to capture selfie image | Ifepay" />
                <meta property="og:description" content="Complete the KYC process by following simple steps like, Look straight, Smile, Frown, turn right. It take maximum of 30 seconds to complete Liveness check." />
                <meta property="og:image" content="https://ifepay.co.uk/assets/images/logo.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://ifepay.co.uk/livenesscheck"/>
            </Helmet>
        </div>
    )
}

export default Livenesscheck_Seo
